import Box from "@mui/material/Box";
import React, { FC } from "react";
import TicketContent from "./components/TicketContent";
import TicketsList from "./components/TicketsList";

const INQUIRIES_HEADER_HEIGHT = 140;

const Inquiries: FC = () => {
  return (
    <Box
      display="flex"
      overflow="hidden"
      maxHeight={`calc(100vh - ${INQUIRIES_HEADER_HEIGHT}px)`}
    >
      <TicketsList />
      <TicketContent />
    </Box>
  );
};

export default Inquiries;
